import { createAsyncThunk } from '@reduxjs/toolkit';
import type { DashboardOverallRequest, DashboardOverallResponse } from '@api/domain/types';
import type { AppDispatch, RootState } from '@store/types';
import { backendCall, createApiCall } from '@reducers/utils';

interface FetchDashboardOverallArgs {
  params: DashboardOverallRequest;
  signal?: AbortSignal;
}

export const fetchDashboardOverall = createAsyncThunk<
  DashboardOverallResponse | undefined,
  FetchDashboardOverallArgs,
  { state: RootState; dispatch: AppDispatch }
>('dashboard/fetchDashboardOverall', async ({ params, signal }, { dispatch }) => {
  return await dispatch(
    backendCall(
      createApiCall((api) => api.dashboard.getDashboardOverall, {
        params,
        signal,
      })
    )
  );
});
